import { Route, Switch } from "wouter";
import { Welcome } from "./pages/Welcome";
import { SignUp } from "./pages/SignUp";
import { ProfileSetup } from "./pages/ProfileSetup";
import { InitialLock } from "./pages/InitialLock";
import { FirstPairRitual } from "./pages/FirstPairRitual";
import { Home } from "./pages/Home";
import { SoloDraw } from "./pages/SoloDraw";
import { PairLaunch } from "./pages/PairLaunch";
import { PairRitual } from "./pages/PairRitual";
import { SimultaneousReveal } from "./pages/SimultaneousReveal";
import { Collection } from "./pages/Collection";
import { Progress } from "./pages/Progress";
import { Settings } from "./pages/Settings";

export function App() {
  return (
    <Switch>
      <Route path="/" component={Welcome} />
      <Route path="/signup" component={SignUp} />
      <Route path="/profile" component={ProfileSetup} />
      <Route path="/lock" component={InitialLock} />
      <Route path="/ritual/first" component={FirstPairRitual} />
      <Route path="/home" component={Home} />
      <Route path="/draw" component={SoloDraw} />
      <Route path="/pair" component={PairLaunch} />
      <Route path="/pair/:pairId/ritual" component={PairRitual} />
      <Route path="/pair/:pairId/reveal" component={SimultaneousReveal} />
      <Route path="/collection" component={Collection} />
      <Route path="/progress" component={Progress} />
      <Route path="/settings" component={Settings} />
      <Route>
        <Welcome />
      </Route>
    </Switch>
  );
}
